export const Types = {

    GET_USER_LIST: "GET_USER_LIST",
    SET_USER_LIST: "SET_USER_LIST",
    RESET_USER_LIST: "RESET_USER_LIST",
    UPDATE_RECORD_OF_USER: "UPDATE_RECORD_OF_USER",
    UPDATE_RECORD_OF_USER_RESPONSE: "UPDATE_RECORD_OF_USER_RESPONSE",
    DELETE_RECORD_OF_USER: "DELETE_RECORD_OF_USER",
    ADD_RECORD_OF_USER: "ADD_RECORD_OF_USER",

    GET_PLANTS_FOR_USER: "GET_PLANTS_FOR_USER",
    SET_PLANTS_FOR_USER: "SET_PLANTS_FOR_USER",
    SET_PLANTS_FOR_USER_PAGE: "SET_PLANTS_FOR_USER_PAGE",

    GET_USER_MENU_LIST: "GET_USER_MENU_LIST",
    GET_USER_PLANT_LIST: "GET_USER_PLANT_LIST",
    GET_USER_INFORMATION: "GET_USER_INFORMATION",
    GET_USER_INTERFACE_LIST: "GET_USER_INTERFACE_LIST",

    GET_USER_DETAIL_BY_ID: "GET_USER_DETAIL_BY_ID",
    GET_USER_GROUP_LIST: "GET_USER_GROUP_LIST",
    GET_USER_ROLE_GROUP_LIST: "GET_USER_ROLE_GROUP_LIST",
    GET_TECHNICIAN_LIST: "GET_TECHNICIAN_LIST",
    UPDATE_USER_GROUP_BY_ID: "UPDATE_USER_GROUP_BY_ID",
    UPDATE_USER_ROLE_GROUP_BY_ID: "UPDATE_USER_ROLE_GROUP_BY_ID",
    SET_USER_ROLE_GROUP_BY_ID: "SET_USER_ROLE_GROUP_BY_ID",
    SET_USER_GROUP_BY_ID: "SET_USER_GROUP_BY_ID",
    SET_USER_GROUP_LIST: "SET_USER_GROUP_LIST",
    SET_USER_ROLE_GROUP_LIST: "SET_USER_ROLE_GROUP_LIST",
    SET_USER_DETAIL_BY_ID: "SET_USER_DETAIL_BY_ID",

    SET_USER_INFO: "SET_USER_INFO",
    SET_USER_MENU_LIST: "SET_USER_MENU_LIST",
    SET_USER_PLANT_LIST: "SET_USER_PLANT_LIST",
    SET_USER_INFORMATION: "SET_USER_INFORMATION",
    SET_USER_INTERFACE_LIST: "SET_USER_INTERFACE_LIST",
    SET_TECHNICIAN_LIST: "SET_TECHNICIAN_LIST",
    SET_SHOW_MESSAGE: "SET_SHOW_MESSAGE",
    RESET_APP_RESPONSE: "RESET_APP_RESPONSE",

    CHECK_USER_ROLE: "CHECK_USER_ROLE",
    SET_CHECK_USER_ROLE: "SET_CHECK_USER_ROLE",

    GET_TECHNICIAN_LIST_BY_POOL_ID: "GET_TECHNICIAN_LIST_BY_POOL_ID",
    SET_TECHNICIAN_LIST_BY_POOL_ID: "SET_TECHNICIAN_LIST_BY_POOL_ID",

    IS_UPDATED_TASK: "IS_UPDATED_TASK",
    RESET_IS_UPDATED_TASK: "RESET_IS_UPDATED_TASK",

    GET_COST_CENTER_FOR_USER: "GET_COST_CENTER_FOR_USER",
    SET_COST_CENTER_FOR_USER: "SET_COST_CENTER_FOR_USER",
    GET_EQUIPMENT_REPORT_GROUP_LIST_FOR_USER: "GET_EQUIPMENT_REPORT_GROUP_LIST_FOR_USER",
    SET_EQUIPMENT_REPORT_GROUP_LIST_FOR_USER: "SET_EQUIPMENT_REPORT_GROUP_LIST_FOR_USER",

    POST_MAINTENANCE_APPROVAL: "POST_MAINTENANCE_APPROVAL",
    GET_MAINTENANCE_APPROVAL: "GET_MAINTENANCE_APPROVAL",
    SET_MAINTENANCE_APPROVAL: "SET_MAINTENANCE_APPROVAL",
};

export const getUserList = (payload) => ({
    type: Types.GET_USER_LIST,
    payload: payload,
});

export const setUserList = (payload) => ({
    type: Types.SET_USER_LIST,
    payload: payload,
});

export const resetList = () => ({
    type: Types.RESET_USER_LIST,
});

export const updateRecord = (payload) => ({
    type: Types.UPDATE_RECORD_OF_USER,
    payload: payload,
});

export const setUpdateRecord = (payload) => ({
    type: Types.UPDATE_RECORD_OF_USER_RESPONSE,
    payload: payload,
});

export const deleteRecord = (payload) => ({
    type: Types.DELETE_RECORD_OF_USER,
    payload: payload,
});

export const addRecord = (payload) => ({
    type: Types.ADD_RECORD_OF_USER,
    payload: payload,
});

export const getPlants = () => ({
    type: Types.GET_PLANTS_FOR_USER,
});

export const setPlants = (payload) => ({
    type: Types.SET_PLANTS_FOR_USER,
    payload: payload,
});

export const setPlantsForUser = (payload) => ({
    type: Types.SET_PLANTS_FOR_USER_PAGE,
    payload: payload,
});

export const resetAppRes = () => ({
    type: Types.RESET_APP_RESPONSE,
});

export const getUserMenuList = () => ({
    type: Types.GET_USER_MENU_LIST,
});

export const setUserMenuList = (payload) => ({
    type: Types.SET_USER_MENU_LIST,
    payload,
});

export const getUserPlantList = (userCode) => ({
    // type: Types.GET_USER_MENU_LIST,
    type: Types.GET_USER_PLANT_LIST,
    payload: userCode,
});

export const setUserPlantList = (payload) => ({
    type: Types.SET_USER_PLANT_LIST,
    payload,
});

export const getUserInfo = (userCode) => ({
    type: Types.GET_USER_INFORMATION,
    payload: userCode,
});

export const setUserInfo = (payload) => ({
    type: Types.SET_USER_INFO,
    payload: payload,
});

export const checkUserRole = (roleFunctionCode) => ({
    type: Types.CHECK_USER_ROLE,
    payload: roleFunctionCode,
});

export const setcheckUserRole = (payload) => ({
    type: Types.SET_CHECK_USER_ROLE,
    payload: payload,
});

export const getUserInterfaceList = () => ({
    type: Types.GET_USER_INTERFACE_LIST,
});

export const setUserInterfaceList = (payload) => ({
    type: Types.SET_USER_INTERFACE_LIST,
    payload,
});

export const showSnackMessage = (payload) => ({
    type: Types.SET_SHOW_MESSAGE,
    payload: payload,
});

export const getUserDetailbyID = (payload) => ({
    type: Types.GET_USER_DETAIL_BY_ID,
    payload: payload,
});

export const setUserDetailbyID = (payload) => ({
    type: Types.SET_USER_DETAIL_BY_ID,
    payload: payload,
});

export const getUserGroupList = () => ({
    type: Types.GET_USER_GROUP_LIST,
});

export const setUserGroupList = (payload) => ({
    type: Types.SET_USER_GROUP_LIST,
    payload: payload,
});

export const getUserRoleGroupList = () => ({
    type: Types.GET_USER_ROLE_GROUP_LIST,
});

export const setUserRoleGroupList = (payload) => ({
    type: Types.SET_USER_ROLE_GROUP_LIST,
    payload: payload,
});

export const updateUserGroupbyId = (payload) => ({
    type: Types.UPDATE_USER_GROUP_BY_ID,
    payload,
});

export const setupdateUserGroupbyId = (payload) => ({
    type: Types.SET_USER_GROUP_BY_ID,
    payload: payload,
});

export const updateUserRoleGroupbyId = (payload) => ({
    type: Types.UPDATE_USER_ROLE_GROUP_BY_ID,
    payload,
});
export const setupdateUserRoleGroupbyId = (payload) => ({
    type: Types.SET_USER_ROLE_GROUP_BY_ID,
    payload: payload,
});
export const getTechnicianListByPoolId = (payload) => ({
    type: Types.GET_TECHNICIAN_LIST_BY_POOL_ID,
    payload: payload,
});
export const setTechnicianListByPoolId = (payload) => ({
    type: Types.SET_TECHNICIAN_LIST_BY_POOL_ID,
    payload: payload,
});

export const isUpdateTask = (payload) => ({
    type: Types.IS_UPDATED_TASK,
    payload,
});

export const resetIsUpdateTask = (payload) => ({
    type: Types.RESET_IS_UPDATED_TASK,
    payload,
});

export const getTechnicianList = (payload) => ({
    type: Types.GET_TECHNICIAN_LIST,
    payload,
});

export const setTechnicianList = (payload) => ({
    type: Types.SET_TECHNICIAN_LIST,
    payload,
});

export const getCostCenterList = () => ({
    type: Types.GET_COST_CENTER_FOR_USER,
});

export const setCostCenterList = (payload) => ({
    type: Types.SET_COST_CENTER_FOR_USER,
    payload: payload,
});

export const getEquipmentReportGroupList = () => ({
    type: Types.GET_EQUIPMENT_REPORT_GROUP_LIST_FOR_USER,
});

export const setEquipmentReportGroupList = (payload) => ({
    type: Types.SET_EQUIPMENT_REPORT_GROUP_LIST_FOR_USER,
    payload: payload,
});

export const postMaintenanceApprovalRights = (payload) => ({
    type: Types.POST_MAINTENANCE_APPROVAL,
    payload: payload,
});

export const getMaintenanceApprovalRights = (payload) => ({
    type: Types.GET_MAINTENANCE_APPROVAL,
    payload: payload,
});

export const setMaintenanceApprovalRights = (payload) => ({
    type: Types.SET_MAINTENANCE_APPROVAL,
    payload: payload,
});

